import { apiHolder as api } from 'api';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig } from '../util';
const systemApi = api.api.getSystemApi();
const isCorpMail = systemApi.getIsCorpMailMode();
const MailListMenuMultConfig2AllFolder = [
    {
        key: MAIL_MENU_ITEM.RED_FLAG,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.READ,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        group: '2',
    },
];
export default findAndMergeDefaultMenuConfig(MailListMenuMultConfig2AllFolder, DefaultMailMenuConfig);
